import React from 'react';
import { Grid, makeStyles, Typography, Box, Container, Button } from '@material-ui/core';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import CarouselBrasil from '../components/CarouselBrasil';
import CardBorder from '../components/CardBorder';
import CarouselPvnVideos from '../components/CarouselBrasilVideos';

// Images
import CwaVector from '../assets/cwa-vector-white.webp';
import Notebook from '../assets/bra-note.webp';
import Bg from '../assets/port-brasil.webp';
import LogoAntes from '../assets/bra-logo-antes.webp';
import LogoDepois from '../assets/bra-logo-depois.webp';
import Material1 from '../assets/bra-material-1.webp';
import Material2 from '../assets/bra-material-2.webp';
import Material3 from '../assets/bra-material-3.webp';
import Material4 from '../assets/bra-material-4.webp';
import Site from '../assets/bra-site.webp';

// Icons
// import { ThumbUpAlt, Language, PlayCircleFilled, Brush, TrendingUp, Description } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
   root: {
      flexGrow: 0,
      backgroundColor: '#000413',
      overflowX: 'hidden',
   },
   section: {
      paddingTop: '4rem',
      position: 'relative',
   },
   primary: {
      color: '#C9A300',
   },
   white: {
      color: theme.palette.common.white,
   },
   appBarColor: {
      background: 'linear-gradient(135deg, rgba(201,163,0,1) 0%, rgba(188,152,0,1) 50%, rgba(181,147,0,1) 75%, rgba(173,141,1,1) 100%);',
   },
   header: {
      background: 'linear-gradient(135deg, rgba(201,163,0,1) 0%, rgba(188,152,0,1) 50%, rgba(181,147,0,1) 75%, rgba(173,141,1,1) 100%);',
      minHeight: '500px',
      [theme.breakpoints.down('sm')]: {
         minHeight: '350px',
      },
   },
   bgVector: {
      backgroundImage: `url(${CwaVector})`,
      minHeight: '500px',
      [theme.breakpoints.down('sm')]: {
         minHeight: '350px',
      },
   },
   buttonOutline: {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#5533FF',
      borderRadius: '4px',
      padding: '1rem',
      color: '#5533FF',
      fontWeight: 'bold',
      textTransform: 'none',
      fontSize: '1rem',
      '&:hover': {
         backgroundColor: '#5533FF',
         color: 'white',
         boxShadow: '0px 6px 30px #5533FF',
      }
   },
   highlighter: {
      color: '#fff',
      marginBottom: '0.5rem',
   },
   highlighter2: {
      color: '#C9A300',
      fontSize: '2rem',
      marginBottom: '1rem',
   },
   cardBorder: {
      textAlign: 'center',
      width: '100%',
   },
   classIcon: {
      display: 'none',
   },
   customizeBox: {
      height: '120px !important',
   },
   box: {
      backgroundColor: '#fff',
      borderRadius: '4px',
      position: 'relative',
      height: '100%',
      boxShadow: '0 26px 30px -10px rgb(0 0 0 / 80%)',
      textAlign: 'center',
   },
}));


export default function BrasilAutomoveis() {
   const classes = useStyles();
   return (
      <div className={classes.root}>
         <TopBar appBarColor={classes.appBarColor} />

         {/* Header */}
         <Box className={`${classes.header}`}>
            <Box className={`${classes.bgVector}`} px={{ xs: 4, md: 8 }} pt={{ xs: 36, md: 48 }}>
               <Container>
                  <Grid container alignItems='center' justifyContent='center' alignContent='center'>
                     <Grid item md='8'>
                        <Box color='white' textAlign={{ xs: 'left', sm: 'center', }} mb={4}>
                           <Typography component='h1' variant='h2' className={classes.white}>
                              Brasil Automóveis
                           </Typography>
                        </Box>
                     </Grid>
                  </Grid>
               </Container>
            </Box>
         </Box>

         {/* Notebook */}
         <Grid container alignContent='center' justifyContent='center'>
            <Grid item>
               <Box mt={{ xs: -32, md: -48 }}>
                  <img src={Notebook} alt='Brasil Automóveis' width='100%' />
               </Box>
            </Grid>
         </Grid>

         {/* Sobre o projeto */}
         <Grid container>
            <Container>
               <Box pt={20} px={{ xs: 4, md: 8 }} pb={{ xs: 15, md: 15 }} textAlign='left'>
                  <Grid container alignContent='center' direction='column'>
                     <Grid item md={6}>
                        <Box mb={2}>
                           <Typography component='h2' variant='h3' className={classes.white}>
                              Sobre o projeto
                           </Typography>
                        </Box>
                     </Grid>
                     <Grid item md={6}>
                        <Typography variant='body1' className={classes.white} gutterBottom='true'>
                           <p>Em um setor onde as concorrentes vendem os mesmos produtos, das mesmas marcas e têm como referência a mesma tabela de preço, tínhamos o desafio de alavancar as vendas através do digital.</p>
                        </Typography>
                        <Typography variant='body1' className={classes.white} gutterBottom='true'>
                           <p>Desenvolvemos um projeto de reposicionamento de marca através de uma comunicação mais clara com o público alvo.</p>
                        </Typography>
                        <Typography variant='body1' className={classes.white} gutterBottom='true'>
                           <p>Desenvolvemos novos serviços, facilitamos a jornada de compra e criamos linhas editoriais para que nossa comunicação atingisse os públicos que nossa estratégia detectou serem os melhores.</p>
                        </Typography>
                        <Typography variant='h6' component="p" className={classes.primary}>
                           Copy, tráfego, design e tecnologia foram ferramentas para alcançarmos todos os objetivos traçados.
                        </Typography>
                     </Grid>
                  </Grid>
               </Box>
            </Container>
         </Grid>

         {/* Identidade visual */}
         <Box mt={{ xs: 24, md: 36 }}>
            <img src={Bg} alt='Brasil Automóveis' width='100%' />
         </Box>
         <Box mt={-42} p={{ xs: 6, md: 12 }}>
            <Grid container justifyContent='center'>
               <Grid item md={6} className={classes.box}>
                  <Box px={8} pt={16} pb={16}>
                     <Grid container justifyContent='space-around' alignItems='center'>
                        <Grid md={3}>
                           <Box mb={{ xs: 16, md: 0 }}><img src={LogoAntes} alt='Brasil Automóveis' width='100%' /></Box>
                        </Grid>
                        <Grid md={3}>
                           <img src={LogoDepois} alt='Brasil Automóveis' width='100%' />
                        </Grid>
                     </Grid>
                  </Box>
               </Grid>
            </Grid>
         </Box>
         <Box px={{ xs: 2, md: 12 }} textAlign='center'>
            <Grid container className={classes.section} justifyContent='center' alignContent='center'>
               <Grid item>
                  <Box px={{ xs: 4, md: 8 }} pb={{ xs: 15, md: 15 }} textAlign='left'>
                     <Grid container justifyContent='left' alignContent='center' direction='column'>
                        <Grid item md={6}>
                           <Box mb={4}>
                              <Typography component='h2' variant='h3' className={classes.white}>
                                 Nova Identidade Visual
                              </Typography>
                           </Box>
                        </Grid>
                        <Grid item md={6}>
                           <Box mb={{ xs: 12, md: 24 }}>
                              <Typography variant='body1' className={classes.white} gutterBottom='true'>
                                 O plano que traçamos demandava uma nova marca. Pensamos na nova identidade visual como uma marca de carros.
                                 Unimos legibilidade com agressividade, unimos símbolo à tipografia e chegamos ao resultado que queríamos:
                                 <Typography variant='h6' component="span" className={classes.primary}> uma marca forte, dinâmica e agressiva.</Typography>
                              </Typography>
                           </Box>
                        </Grid>
                     </Grid>
                  </Box>
               </Grid>
               <Grid item md={3}>
                  <img src={Material1} alt='Brasil Automóveis' />
               </Grid>
               <Grid item md={3}>
                  <img src={Material2} alt='Brasil Automóveis' />
               </Grid>
               <Grid item md={3}>
                  <img src={Material3} alt='Brasil Automóveis' />
               </Grid>
               <Grid item md={3}>
                  <img src={Material4} alt='Brasil Automóveis' />
               </Grid>
            </Grid>
         </Box>

         {/* Artes para redes sociais */}
         <Grid container className={classes.section} justifyContent='center' alignItems='center'>
            <Container>
               <Box pt={{ xs: 28, md: 48}} px={4} pb={10} textAlign={{ xs: 'left', md: 'center' }}>
                  <Grid container justifyContent='center' alignItems='center'>
                     <Typography component='h2' variant='h3' className={classes.white}>
                        Artes para redes sociais
                     </Typography>
                  </Grid>
               </Box>
            </Container>
            <Box width='100%' mb={{ xs: 18, md: 48 }}>
               <CarouselBrasil />
            </Box>
         </Grid>

         {/* Edição de vídeo */}
         <Container>
            <Grid container className={classes.section} justifyContent='center' alignContent='center' alignItems='center'>
               <Grid item md={12}>
                  <Box pt={{ xs: 18, md: 24 }} px={4} pb={10} textAlign={{ xs: 'left', md: 'center' }}>
                     <Grid container justifyContent='center' alignItems='center'>
                        <Typography component='h2' variant='h4' className={classes.white}>
                           Edição de vídeos
                        </Typography>
                     </Grid>
                  </Box>
               </Grid>
               {/* <Grid item md={7}> */}
                  <Box width='100%' mb={{ xs: 18, md: 48 }}>
                     <CarouselPvnVideos />
                  </Box>
               {/* </Grid> */}
            </Grid>
         </Container>

         {/* Gestão de tráfego */}
         <Box px={{ xs: 2, md: 12 }}>
            <Grid container className={classes.section} justifyContent='center' alignContent='center'>
               <Grid item>
                  <Box px={{ xs: 4, md: 8 }} pb={{ xs: 10, md: 10 }} textAlign='left'>
                     <Grid container justifyContent='left' alignContent='center' direction='column'>
                        <Grid item md={6}>
                           <Box mb={2}>
                              <Typography component='h2' variant='h3' className={classes.white}>
                                 Gestão de tráfego
                              </Typography>
                           </Box>
                        </Grid>
                        <Grid item md={6}>
                           <Box mb={{ xs: 12, md: 24 }}>
                              <Typography variant='body1' className={classes.white} gutterBottom='true'>
                                 <p>Após o cenário ajustado, atendimento reformulado e comunicação reposicionada, iniciamos nosso processo de gestão de tráfego com anúncios em Facebook/Instagram e Google.</p>
                              </Typography>
                              <Typography variant='body1' className={classes.white} gutterBottom='true'>
                                 <p>Desenvolvemos campanhas de distribuição de conteúdo, conversão e geração de lead. <Typography variant='h6' component="span" className={classes.primary}>O feedback do nosso cliente nos mostra que hoje, 80% dos carros são vendidos através da internet.</Typography></p>
                              </Typography>
                           </Box>
                        </Grid>
                     </Grid>
                  </Box>
               </Grid>
               <Grid item>
                  <Box px={{ xs: 4, md: 8 }} mb={20} width='100%'>
                     <Grid container alignContent='center' justifyContent='space-between' spacing={8}>
                        <CardBorder
                           col='4'
                           cardBorder={classes.cardBorder}
                           classIcon={classes.classIcon}
                           classHighlighter={classes.highlighter2}
                           highlighter='+ R$ 200.000'
                           text='investidos em tráfego'
                        />
                        <CardBorder
                           col='4'
                           cardBorder={classes.cardBorder}
                           classIcon={classes.classIcon}
                           classHighlighter={classes.highlighter2}
                           highlighter='+ 10 milhões'
                           text='de pessoas impactadas com nossos anúncios.'
                        />
                        <CardBorder
                           col='4'
                           cardBorder={classes.cardBorder}
                           classIcon={classes.classIcon}
                           classHighlighter={classes.highlighter2}
                           highlighter='+ 70%'
                           text='de aumento em vendas através dos nossos anúncios.'
                        />
                     </Grid>
                  </Box>
               </Grid>
            </Grid>
         </Box>

         {/* Novo site e Landing Page */}
         <Box pt={{ xs: 30, md: 42 }} textAlign='center'>
            <Grid container justifyContent='center' alignItems='center'>
               <Grid item md={12}>
                  <Typography component='h2' variant='h3' className={classes.white}>
                     <Box mb={16}>Novo site e Landing Page</Box>
                  </Typography>
               </Grid>
               <Grid item md={12}>
                  <img src={Site} alt='Site da Braisl automóveis' width='100%' />
               </Grid>
            </Grid>
         </Box>

         {/* Pronto para impulsionar suas vendas? */}
         <Grid container className={`${classes.section} ${classes.bg1}`}>
            <Container>
               <Box pt={24} px={{ xs: 4, md: 8 }} pb={{ xs: 15, md: 25 }} textAlign={{ xs: 'left', md: 'center' }}>
                  <Grid container justifyContent='center' alignItems='center' direction='column'>
                     <Grid item md={8}>
                        <Typography variant='h4' className={classes.white}>
                           <Box mb={2}>Pronto para impulsionar suas vendas?</Box>
                        </Typography>
                     </Grid>
                     <Grid item lg={4}>
                        <Typography variant='body2' className={classes.white} gutterBottom='true'>
                           <Box mb={8}>
                              Fale agora com um dos nossos especialistas
                              e nos conte sobre seu negócio.
                           </Box>
                        </Typography>
                     </Grid>
                     <Grid item lg={5}>
                        <Button variant='outlined' className={classes.buttonOutline} href='https://api.whatsapp.com/send?phone=5521981031917&text=Ol%C3%A1,%20CWA%20Digital!%20Gostaria%20de%20conversar%20sobre%20meu%20negócio.'>Começar agora</Button>
                     </Grid>
                  </Grid>
               </Box>
            </Container>
         </Grid>

         <Footer />
      </div >
   );
}